import { useEffect } from 'react';
import isDevelopmentEnvironment from '../helpers/isDevelopmentEnvironment';

const sunsetComponents: string[] = [];

function useSunsetWarning({ componentName, substitute }: { componentName: string; substitute: string }) {
  useEffect(() => {
    if (isDevelopmentEnvironment() && !sunsetComponents.includes(componentName)) {
      console.warn(`${componentName} will be deprecated soon. Consider using ${substitute} instead.`);
      sunsetComponents.push(componentName);
    }
  }, [componentName, substitute]);
}

export default useSunsetWarning;
